import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import ModuleList from '../../../layout/ModuleList';
import { CARGO_ITEM_PATH } from '../../../../config/paths';
import {
  clearCargoItems,
  clearShelves,
  getCargoItemsExcel,
  getCargoItemsV2,
  getShelfByLocation,
} from '../../../../actions';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import {
  DEFAULT_PAGE_SIZE,
  FILTER_DEPENDENCIES_CARGO_ITEM_DOWNLOAD,
  REQUIRED_CARGO_ITEM_DOWNLOAD_FILTERS,
} from '../../../../config/constants';
import { generateCargoItemsColumnsTable } from '../../../../config/columns';

export const CargoItems = ({
  breadcrumbs,
  cargoItems,
  loading,
  dispatchGetCargoItems,
  dispatchClearCargoItems,
  dispatchGetCargoItemsExcel,
  dispatchClearShelves,
  dispatchGetShelfByLocation,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearCargoItems();
      dispatchClearShelves();
    },
    [],
  );

  const data = cargoItems.get('content') || [];
  const pages = cargoItems.get('totalPages') || null;
  const defaultPageSize = cargoItems.get('size') || DEFAULT_PAGE_SIZE;
  const [locationSelected, setLocationSelected] = useState([]);

  useEffect(() => {
    if (locationSelected.length > 0 && locationSelected[0] !== null) {
      dispatchGetShelfByLocation(locationSelected[0]);
      return;
    }
    dispatchClearShelves();
  }, [locationSelected]);

  const columns = useMemo(
    () => generateCargoItemsColumnsTable(setLocationSelected),
    [],
  );

  return (
    <ModuleList
      title="Lista de Encomiendas"
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetCargoItems,
        modelPath: CARGO_ITEM_PATH,
        loading,
        navigateToModelOnRowClick: true,
        showDownloadButton: true,
        downloadFetchData: dispatchGetCargoItemsExcel,
        requiredDownloadFilters: REQUIRED_CARGO_ITEM_DOWNLOAD_FILTERS,
        filterDependencies: FILTER_DEPENDENCIES_CARGO_ITEM_DOWNLOAD,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetCargoItems: getCargoItemsV2,
  dispatchClearCargoItems: clearCargoItems,
  dispatchGetCargoItemsExcel: getCargoItemsExcel,
  dispatchGetShelfByLocation: getShelfByLocation,
  dispatchClearShelves: clearShelves,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Encomiendas',
      href: CARGO_ITEM_PATH,
    },
  ],
  cargoItems: CargoUnit.CargoItem.getIn(['all', 'content']),
  loading: CargoUnit.CargoItem.getIn(['all', 'loading']),
});

CargoItems.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cargoItems: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetCargoItems: PropTypes.func.isRequired,
  dispatchClearCargoItems: PropTypes.func.isRequired,
  dispatchGetCargoItemsExcel: PropTypes.func.isRequired,
  dispatchClearShelves: PropTypes.func.isRequired,
  dispatchGetShelfByLocation: PropTypes.func.isRequired,
};

CargoItems.defaultProps = {
  cargoItems: Immutable.Map(),
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(CargoItems);
